import { TranslationObject } from '@ngx-translate/core';
import { Source } from '@lib.core/entities/source/source';
import { Topic } from '@lib.core/entities/topic/topic';
import { Tag } from '@lib.core/entities/tag/tag';
import { KPI } from '@lib.core/entities/indicator/kpi';
import { AspectType } from '@lib.core/entities/indicator-type/indicator-type';

export class AspectSummary {
  title: TranslationObject;
  description?: TranslationObject;
  brief?: TranslationObject;
  type: AspectType;
  kpi?: KPI;
  kpiSecondary?: KPI;
  source?: Source[];
  topic: Topic;
  tags?: Tag[];
  lastUpdatedAt: Date;

  constructor(
    title: TranslationObject,
    description: TranslationObject | undefined,
    brief: TranslationObject | undefined,
    type: AspectType,
    source: Source[] | undefined,
    topic: Topic,
    lastUpdatedAt: Date,
    tags?: Tag[],
    kpi?: KPI,
    kpiSecondary?: KPI
  ) {
    this.title = title;
    this.description = description;
    this.brief = brief;
    this.type = type;
    this.kpi = kpi;
    this.kpiSecondary = kpiSecondary;
    this.source = source;
    this.topic = topic;
    this.tags = tags;
    this.lastUpdatedAt = lastUpdatedAt;
  }
}